import { withDependencies, named, optional } from '@wix/thunderbolt-ioc'
import type {
	IAppWillMountHandler,
	IHeadContent,
	Experiments
} from '@wix/thunderbolt-symbols'
import {
	SiteFeatureConfigSymbol,
	HeadContentSymbol,
	ExperimentsSymbol
} from '@wix/thunderbolt-symbols'
import type { IMpaNavigation } from 'feature-mpa-navigation'
import { MpaNavigationSymbol } from 'feature-mpa-navigation'
import type { SpeculationRulesSiteConfig, SpeculationRulesConfig } from './types'
import { name } from './symbols'

/**
 * Adds speculation rules to the head when MPA navigation is eligible
 */
export const SpeculationRules = withDependencies(
	[named(SiteFeatureConfigSymbol, name), HeadContentSymbol, ExperimentsSymbol, optional(MpaNavigationSymbol)],
	(
		siteFeatureConfig: SpeculationRulesSiteConfig,
		headContent: IHeadContent,
		experiments: Experiments,
		mpaNavigation?: IMpaNavigation
	): IAppWillMountHandler => {
		return {
			async appWillMount() {
				// Check if MPA navigation is eligible
				const isMpaEligible = mpaNavigation?.isEligible() ?? false

				if (isMpaEligible) {
					const isExcludeCurrentUrlEnabled = !!experiments['specs.thunderbolt.ExcludeCurrentUrlFromSpeculationRules']

					const speculationRulesConfig: SpeculationRulesConfig = isExcludeCurrentUrlEnabled
						? {
							prefetch: [
								{
									tag: 'mpa-prefetch-moderate',
									where: {
										and: [
											{ href_matches: '/*' },
											// Exclude the current page to avoid prefetching it
											// Pattern matches current path with optional query params/hash
											{
												not: {
													href_matches: `${siteFeatureConfig.currentPagePath}`
												}
											}
										]
									},
									eagerness: 'moderate',
								},
							],
						}
						: {
							prefetch: [
								{
									tag: 'mpa-prefetch-moderate',
									where: { href_matches: '/*' },
									eagerness: 'moderate',
								},
							],
						}

					headContent.setHead(
						`<script type="speculationrules">${JSON.stringify(speculationRulesConfig)}</script>`
					)
				}
			},
		}
	}
)
